function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 Elevea Consulting</p>
    </footer>
  );
}

export default Footer;